import React, { useEffect, useState } from "react";
import { History, ArrowDown, ArrowUp } from "lucide-react";
import api from "../../lib/api";

export default function AdminStockHistory() {
  const [entries, setEntries] = useState(null);
  const [products, setProducts] = useState([]);
  const [productId, setProductId] = useState("");

  useEffect(() => {
    api.get("/products").then((r) => setProducts(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    const params = productId ? `?product_id=${productId}` : "";
    api.get(`/admin/stock-history${params}`).then((r) => setEntries(r.data)).catch(() => setEntries([]));
  }, [productId]);

  return (
    <div data-testid="admin-stock-history">
      <div className="overline text-zinc-500">Inventory</div>
      <h1 className="font-display text-2xl sm:text-3xl font-bold tracking-tight mb-2">Stock history</h1>
      <p className="text-sm text-zinc-500 mb-6">
        Every stock change — from orders, restocks, or manual adjustments — is logged here.
      </p>

      <div className="mb-4">
        <select className="border border-zinc-200 rounded-lg px-3 py-2 text-sm"
                value={productId} onChange={(e) => setProductId(e.target.value)}
                data-testid="stock-history-product">
          <option value="">All products</option>
          {products.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}
        </select>
      </div>

      {entries === null ? (
        <div className="text-sm text-zinc-500">Loading…</div>
      ) : entries.length === 0 ? (
        <div className="rounded-xl border border-dashed border-zinc-200 p-10 text-center">
          <History size={28} className="mx-auto text-zinc-300 mb-3" />
          <p className="text-sm text-zinc-500">No stock movements yet.</p>
        </div>
      ) : (
        <div className="rounded-xl border border-zinc-200 bg-white overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-sm min-w-[700px]">
              <thead className="bg-zinc-50 text-zinc-500 text-xs">
                <tr>
                  <th className="text-left px-4 py-3">When</th>
                  <th className="text-left px-4 py-3">Product</th>
                  <th className="text-right px-4 py-3">Change</th>
                  <th className="text-right px-4 py-3">Previous</th>
                  <th className="text-right px-4 py-3">New</th>
                  <th className="text-left px-4 py-3">Reason</th>
                  <th className="text-left px-4 py-3">By</th>
                </tr>
              </thead>
              <tbody>
                {entries.map((e) => (
                  <tr key={e.id} className="border-t border-zinc-100" data-testid={`stock-entry-${e.id}`}>
                    <td className="px-4 py-3 text-xs text-zinc-500 whitespace-nowrap">{new Date(e.created_at).toLocaleString()}</td>
                    <td className="px-4 py-3 font-semibold">{e.product_name}</td>
                    <td className={`px-4 py-3 text-right font-bold ${e.change >= 0 ? "text-green-600" : "text-red-600"}`}>
                      <span className="inline-flex items-center gap-1">
                        {e.change >= 0 ? <ArrowUp size={10} /> : <ArrowDown size={10} />}
                        {e.change >= 0 ? `+${e.change}` : e.change}
                      </span>
                    </td>
                    <td className="px-4 py-3 text-right text-zinc-500">{e.previous_stock}</td>
                    <td className="px-4 py-3 text-right font-semibold">{e.new_stock}</td>
                    <td className="px-4 py-3"><span className="text-xs bg-zinc-100 px-2 py-0.5 rounded">{e.reason}</span></td>
                    <td className="px-4 py-3 text-xs text-zinc-500">
                      {e.user_name || "—"}
                      {e.note && <div className="text-[10px] text-zinc-400">{e.note}</div>}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
